import type { SVGProps } from "react";

export function IconBluePackage(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_8880_5892)">
        <rect opacity="0.5" width="56" height="56" fill="#E4E7FC" />
        <rect
          x="16"
          y="16"
          width="24"
          height="24"
          fill="#5486FA"
          stroke="#5486FA"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <path
          d="M28 16V21"
          stroke="#1C1719"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <path
          d="M36 29L32.2477 32.7523C30.8085 34.1915 28.8566 35 26.8213 35H26C22.6863 35 20 32.3137 20 29V29M36 29H31M36 29V34"
          stroke="#1C1719"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_8880_5892">
          <rect width="56" height="56" rx="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
